import { render, staticRenderFns } from "./CheckMerchantNewsManage.vue?vue&type=template&id=018e1c1d&scoped=true"
import script from "./CheckMerchantNewsManage.vue?vue&type=script&lang=js"
export * from "./CheckMerchantNewsManage.vue?vue&type=script&lang=js"
import style0 from "./CheckMerchantNewsManage.vue?vue&type=style&index=0&id=018e1c1d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018e1c1d",
  null
  
)

export default component.exports